import * as React from "react";
import { Kbd, KbdGroup } from "@volca/ui/components/ui/kbd";
import {
  joinShortcutAriaLabels,
  resolveShortcutKeys,
  type DesktopPlatform,
  type ShortcutKey,
} from "@volca/ui/lib/desktop-platform";

export interface ShortcutKbdProps
  extends Omit<React.HTMLAttributes<HTMLElement>, "children"> {
  keys: readonly ShortcutKey[];
  platform?: DesktopPlatform;
}

const ShortcutKbd = React.forwardRef<HTMLElement, ShortcutKbdProps>(
  ({ keys, platform, className, ...props }, ref) => {
    const resolved = resolveShortcutKeys(keys, platform);

    return (
      <KbdGroup
        ref={ref as React.Ref<HTMLDivElement>}
        role="group"
        aria-label={joinShortcutAriaLabels(resolved)}
        className={className}
        {...props}
      >
        {resolved.map(({ label }, index) => (
          <Kbd key={index} aria-hidden>
            {label}
          </Kbd>
        ))}
      </KbdGroup>
    );
  },
);
ShortcutKbd.displayName = "ShortcutKbd";

export { ShortcutKbd };
